import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'fac_does_not_use_any_methods_and_is_not_aware_of_changesupdates'

export const dataPointDefinition = {
  retracedId: 'fac_does_not_use_any_methods_and_is_not_aware_of_changesupdates',
  name: 'Facility does not use any methods and is not aware of changes/updates',
  meta: {},
  fieldTypeId: 'BOOLEAN',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'boolean',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-6--1-14x',
      version: '1.3',
      provider: 'slcp',
    },
  ],
  sortingId: 23340,
  sectionId: '2.2.6.12',
  impactArea: 'Management Systems',
  impactAreaId: 'MANAGEMENT_SYSTEMS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
